<script>
import Vue from "vue";
import {mapActions, mapGetters} from "vuex";

export default {
  name: "ErrorsAlert",

  computed: {
    ...mapGetters({
      errors: 'error_portfolio/errors',
    }),

  },
  methods: {
    ...mapActions({
      addError: 'error_portfolio/addError',
      clearErrors: 'error_portfolio/clearErrors',
    }),

    clearError (index, error) {
      this.errors[index].show = false;
      this.clearErrors(error);
    },

    calcMargin(i) {
      return (i*60) + 'px'
    },

  },

}
</script>

<template>
  <div>
    <v-snackbar
      v-for="(error, index) in errors"
      :key="error.key"
      v-model="error.show"
      :timeout="3000"
      color="error"
      :style="{'margin-bottom':calcMargin(index)}"
      @input="clearError(index, error)"
      content-class="rounded-lg"
    >
      <v-icon small left>fa-exclamation-triangle</v-icon> {{ error.message }}
      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          icon
          v-bind="attrs"
          @click="clearError(index, error)"
        >
          <v-icon>fa-times</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<style scoped>

</style>